import { useEffect } from "react";
import axios from "axios";
import { appConstants } from "../_constants/app.constants";

const VISITOR_KEY = "tournamentAnalyticsVisitorId";
const SESSION_PREFIX = "tournamentAnalyticsSession:";
const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

function newId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function getVisitorId() {
  try {
    const stored = localStorage.getItem(VISITOR_KEY);
    if (stored) return stored;
    const created = newId();
    localStorage.setItem(VISITOR_KEY, created);
    return created;
  } catch {
    return newId();
  }
}

function getSessionId(tournamentId) {
  const now = Date.now();
  const key = `${SESSION_PREFIX}${tournamentId}`;

  try {
    const stored = JSON.parse(localStorage.getItem(key) || "null");
    const active =
      stored?.id &&
      Number.isFinite(stored?.lastSeen) &&
      now - stored.lastSeen < SESSION_TIMEOUT_MS;
    const id = active ? stored.id : newId();
    localStorage.setItem(key, JSON.stringify({ id, lastSeen: now }));
    return id;
  } catch {
    return newId();
  }
}

function getExternalReferrerHost() {
  try {
    if (!document.referrer) return null;
    const referrer = new URL(document.referrer);
    return referrer.origin === window.location.origin ? null : referrer.hostname;
  } catch {
    return null;
  }
}

export function useTournamentPageView(tournamentId, page) {
  useEffect(() => {
    if (!tournamentId || !page) return;
    if (
      navigator.doNotTrack === "1" ||
      window.doNotTrack === "1" ||
      navigator.globalPrivacyControl === true
    ) {
      return;
    }

    axios
      .post(
        `${appConstants.API_URL}/api/tournaments/${tournamentId}/analytics/page-view`,
        {
          visitorId: getVisitorId(),
          sessionId: getSessionId(tournamentId),
          page,
          referrerHost: getExternalReferrerHost(),
        },
        { timeout: 5000 }
      )
      .catch(() => {
        // Analytics must never interrupt the public tournament experience.
      });
  }, [tournamentId, page]);
}
